import Button from '@/components/shared/Button/button.component';
import Typography from '@/components/shared/typography/typography.component';
import { useTranslation } from '@/hook';
import { BookingButtonTypes } from '@/types';
import Image from 'next/image';
import { FC } from 'react';

interface ControllersButtonsProps {
    type: BookingButtonTypes;
    icon: any;
    text: string;
    onClick: () => void;
}

const ControllerButtons: FC<ControllersButtonsProps> = ({
    icon,
    text,
    type,
    onClick,
}) => {
    const { t } = useTranslation();
    if (type === BookingButtonTypes.Payments) {
        return (
            <Button
                className={
                    '!bg-primary-50 !w-full !h-8 !text-primary-700 !border-primary-50 gap-1'
                }
                onClick={e => {
                    e.stopPropagation();
                    onClick();
                }}
            >
                <Image src={icon} alt={text} width={16} />
                <Typography variant="caption" className="ar:mt-1 !font-[500]">
                    {text}
                </Typography>
            </Button>
        );
    } else if (
        type === BookingButtonTypes.Call ||
        type === BookingButtonTypes.Directions
    ) {
        return (
            <Button
                onClick={e => {
                    e.stopPropagation();
                    onClick();
                }}
                className={
                    '!bg-white !w-full !h-8 !text-gray-700 !border-gray-300 gap-1'
                }
            >
                <Image src={icon} alt={text} width={16} />
                <Typography variant="caption" className="ar:mt-1 !font-[500]">
                    {t(`${text.toLocaleLowerCase()}`)}
                </Typography>
            </Button>
        );
    } else return <></>;
};
export default ControllerButtons;
